import { PushApi } from 'api';
import { useAuthMutation, useQueryClient } from 'queries/query';
import { KEY } from './keys';
import { getQueryKeys } from 'queries/query-key';

function useCancel() {
  const queryClient = useQueryClient();
  return useAuthMutation(PushApi.cancel, {
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: getQueryKeys([KEY]).details(),
      });
      queryClient.invalidateQueries({
        queryKey: getQueryKeys([KEY]).lists(),
      });
    },
  });
}

export default useCancel;
